import { ColorEnum } from '@/constants/color'
import Button from '@/features/ui/buttons/components/Button'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { FC } from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface DestructiveButtonProps {
    children?: string
    disabled?: boolean
    icon?: boolean
    onPress: () => void
    style?: StyleProp<ViewStyle>
}

const DestructiveButton: FC<DestructiveButtonProps> = ({
    disabled = false,
    icon,
    children = '',
    onPress,
    style,
}) => {
    const { styles } = useStyles(stylesheet, { disabled })

    return (
        <Button
            disabled={disabled}
            FrontIcon={icon ? CloseIcon : undefined}
            onPress={onPress}
            style={[styles.button, style]}
        >
            {children}
        </Button>
    )
}

const stylesheet = createStyleSheet({
    button: {
        flexGrow: 1,
        justifyContent: 'center',
        height: 44,
        maxWidth: 164,
        variants: {
            disabled: {
                false: {
                    backgroundColor: ColorEnum.BRICK_500,
                },
            },
        },
    },
})

export default DestructiveButton
